import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { Reveal, Shell } from "@/components/layout/Shell";
import { RichHtml } from "@/components/RichText";

export default function PostPage() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api(`/public/post/${postId}`).then(setPost).catch(e => setError(e.message)); }, [postId]);

  return (
    <Shell>
      <main className="inner-page">
        <div className="container post-page">
          <Link to="/news" className="text-link" data-testid="post-back"><ArrowLeft size={13} /> All news & notices</Link>
          {error ? (
            <div className="empty-state" data-testid="post-error">{error}</div>
          ) : !post ? (
            <div className="empty-state" data-testid="post-loading">Loading…</div>
          ) : (
            <Reveal>
              <article className="post" data-testid="post-article">
                <span className="card-kicker">{post.category || (post.kind === "notice" ? "Notice" : "News")}</span>
                <h1 data-testid="post-title">{post.title}</h1>
                {post.date && <small className="post-date"><CalendarDays size={12} /> {isNaN(Date.parse(post.date)) ? post.date : formatDate(post.date)}</small>}
                {post.image && <img className="post-cover" src={post.image} alt="" />}
                {post.content ? <RichHtml html={post.content} testId="post-content" /> : <p className="post-excerpt" data-testid="post-excerpt">{post.excerpt || post.description || "Details will be published soon."}</p>}
              </article>
            </Reveal>
          )}
        </div>
      </main>
    </Shell>
  );
}
